import { apiUrl } from "../../../../Constant/apiConstant"
import { getRequest, postFormRequest, postJsonRequest } from "../../../../service/apiService"

export const getAllUsers=async(tenant: string | undefined,payLoad:any)=>{
    try{
        const response =await postJsonRequest(apiUrl.UM_GET_GET_USERS,payLoad,tenant,true)

        if(response.status === 200){
            const {Status,Data,TotalUsers}=response.data

            if(Status){
                return {data:Data,totalUsers:TotalUsers}
            }
            return null
        }
    }catch(error){
        console.log(error)
    }
    return null
}

export const deleteUser = async (tenant: string | undefined,payLoad:any)=>{
    try{
        const response =await postJsonRequest(apiUrl.UM_POST_DELETE_USER,payLoad,tenant,true)
        if(response.status === 200){
            const {Status}=response.data

            return Status
        }
    }catch(error){
        console.log(error)
    }
    return false
}

export const editUser = async (tenant: string | undefined,payLoad:any)=>{
    try{
        const response=await postJsonRequest(apiUrl.UM_POST_EDIT_USER,payLoad,tenant,true)
        if(response.status === 200){
            const {Status}=response.data
            return Status
        }
    }catch(error){
        console.log(error)
    }
    return false
}

export const editUserImage = async (tenant: string | undefined,formData:any) =>{
    try{
        const response = await postFormRequest(apiUrl.UM_POST_EDIT_USER_IMAGE,formData,tenant,true)

        if(response.status === 200){
            const {Status}=response.data

            return Status
        }
    }catch(error){
        console.log(error)
    }
    return false
}

export const addUser = async (tenant : string | undefined,payLoad:any) =>{
    try{
        const response = await postJsonRequest(apiUrl.UM_POST_ADD_USER,payLoad,tenant,true)
        if(response.status === 200){
            const { Status,UserNum}=response.data

            if(Status){
                return UserNum
            }
            return null
        }
    }catch(error){
        console.log(error)
    }
    return null
}

export const addUserImage = async (tenant: string | undefined,formData:any) =>{
    try{
        const response = await postFormRequest(apiUrl.UM_POST_ADD_USER_IMAGE,formData,tenant,true)

        if(response.status === 200){
            const {Status}=response.data
            return Status
        }
    }catch(error){
        console.log(error)
    }
    return false
}

export const checkUseridExists = async (tenant: string | undefined,payLoad:any)=>{
    try{
        const response = await postJsonRequest(apiUrl.UM_POST_CHECK_USERID_EXISTS,payLoad,tenant,false)
        if(response.status === 200){
            const {Status}=response.data
            return Status
        }
    }catch(error){
        console.log(error)
    }
    return false
}

export const getUser= async (tenant:string | undefined)=>{
    try{
        const response=await getRequest(apiUrl.UM_GET_USER,{},tenant,true)
        if(response.status === 200){
            const {Status,Data}=response.data

            if(Status){
                return Data
            }
            return null
        }
    }catch(error){
        console.log(error)
    }
    return null
}